<template>
	<div class="rounded-lg bg-secondary-800 border border-[#3D414C]/60 px-3 py-4 space-y-3.5">
		<header class="flex justify-between items-center text-neutral-50 text-xs">
			<p>{{ $t('Date won') }}</p>
			<p>{{ $t('Past Prize Amount') }}</p>
		</header>
		<div
			class="flex justify-between items-center text-neutral-50 text-sm font-semibold border-b border-neutral-800 pb-5"
		>
			<p class="capitalize">{{ props.lottery.date }}</p>
			<p class="text-primary-400">
				{{ formatCurrency(props.lottery.jackpot, props.lottery.type_currency) }}
			</p>
		</div>
		<div class="pt-2 space-y-3.5">
			<p class="text-xs leading-5 text-neutral-50">{{ $t('Tracked numbers') }}</p>
			<div
				class="px-3 xl:px-2 pt-3 pb-1.5 rounded-xl bg-[#262930] bg-opacity-50 border border-[#3D414C] border-opacity-60"
			>
				<BoxNumbers
					:numbers="props.lottery.numbers"
					:show-btn-detail="props.showBtnDetail"
					class="w-fit mx-auto"
					:class="{ 'max-w-56': detailResultStore?.lottery_id === ID_LOTTO_FACIL }"
					:class-container-first-block="getClassFirstBlock"
				/>
			</div>
		</div>
	</div>
</template>

<script setup>
import BoxNumbers from '~/components/pages/results/BoxNumbers'
import { useDetailResultStore } from '~/store/detail_result'
import { formatCurrency } from '~/utils/formatCurrency'
import { ID_LOTTO_FACIL } from '~/utils/constants/idsLotteries.js'

defineOptions({
	name: 'CardDetailResult',
})

const props = defineProps({
	lottery: {
		type: Object,
		required: true,
	},
	showBtnDetail: {
		type: Boolean,
		required: true,
	},
})

const detailResultStore = useDetailResultStore()
const { t: $t } = useI18n()

const getClassFirstBlock = computed(() => {
	if (detailResultStore?.lottery_id === ID_LOTTO_FACIL)
		return 'flex flex-wrap justify-center sm:justify-between items-center gap-y-5 sm:gap-y-3 gap-x-2.5'
	return 'flex flex-wrap gap-y-3 gap-x-1 xl:gap-x-0.5'
})
</script>
